const CART_REDIRECT_DELAY = 700;

class ProductCardForm extends HTMLElement {
  connectedCallback() {
    this.formElement = this.querySelector('[data-product-card-form]');
    this.buttonElement = this.querySelector('[data-add-to-cart-button]');
    this.buttonTextElement = this.querySelector('[data-add-to-cart-button-text]');
    this.errorElement = this.querySelector('[data-product-card-error]');

    if (!this.formElement || !this.buttonElement) return;

    this.handleFormSubmit = this.addProductToCart.bind(this);
    this.formElement.addEventListener('submit', this.handleFormSubmit);
  }

  disconnectedCallback() {
    if (this.formElement && this.handleFormSubmit) {
      this.formElement.removeEventListener('submit', this.handleFormSubmit);
    }
  }

  async addProductToCart(submitEvent) {
    submitEvent.preventDefault();

    if (this.buttonElement.getAttribute('aria-busy') === 'true') return;

    this.setLoadingState(true);
    this.hideErrorMessage();

    try {
      const response = await fetch(`${this.formElement.action}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.formElement),
      });
      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.description || responseData.message);
      }

      this.setLoadingState(false);
      this.showAddedToCartText();
      setTimeout(() => {
        window.location.href = window.PXUTheme.routes.cart_url;
      }, CART_REDIRECT_DELAY);
    } catch (error) {
      this.showErrorMessage(error.message);
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    this.buttonElement.setAttribute('aria-busy', isLoading);
    this.buttonElement.disabled = isLoading;
  }

  showAddedToCartText() {
    const addedToCartText = this.buttonElement.dataset.addedToCartText;

    if (!this.buttonTextElement || !addedToCartText) return;

    this.buttonTextElement.textContent = addedToCartText;
  }

  showErrorMessage(message) {
    if (!this.errorElement || !message) return;

    this.errorElement.textContent = message;
    this.errorElement.hidden = false;
  }

  hideErrorMessage() {
    if (!this.errorElement) return;

    this.errorElement.textContent = '';
    this.errorElement.hidden = true;
  }
}

if (!customElements.get('product-card-form')) {
  customElements.define('product-card-form', ProductCardForm);
}
